import React from "react";
import styles from  "../assets/css/Loading.module.css";

function Loading() {
  return (
    <div className={styles.loadingModal}>
      <div>
        <span className={styles.text}>Loading</span>
        <div className={styles.loader} />
      </div>
    </div>
  );
}

export default Loading;